import {
    CustomFieldStructure,
    FieldStructure,
    InputFieldStructure,
} from '@mercell/form-react';
import { FormDefinitionItem } from '../../types/generated/formDefinitionItem';
import { getRulesSetup } from '../getRulesSetup';
import * as yup from 'yup';
import { TFunction } from 'react-i18next';
import {
    normalizeNumberString,
    createNumericFieldRender,
    isValidNumericString,
} from './numericFieldUtils';

const parseToString = (value: string): string => {
    const normalized = normalizeNumberString(value);
    if (normalized === '') {
        return '';
    }
    if (!isValidNumericString(normalized)) {
        return value;
    }
    const parsed = parseFloat(normalized);
    return Number.isNaN(parsed) ? value : normalized;
};

const formatForEditing = (value: string | null | undefined): string => value ?? '';

export const mapTextField = (
    formDefinition: FormDefinitionItem,
    genericFieldStructure: FieldStructure,
    t: TFunction<string, unknown>,
    language?: string,
    enableNumericFormatting?: boolean
): InputFieldStructure | CustomFieldStructure => {
    const locale = language ?? 'en-GB';
    const isNumeric = enableNumericFormatting && formDefinition.isNumeric;

    let validations;
    if (formDefinition.rules) {
        validations = getRulesSetup(
            yup.string().nullable(),
            formDefinition.rules,
            t,
            formDefinition.businessTerm
        );
    }

    if (formDefinition.conditionalValidation?.rules) {
        const conditionalValidations = getRulesSetup(
            yup.string().nullable(),
            formDefinition.conditionalValidation.rules,
            t,
            formDefinition.businessTerm
        );
        if (genericFieldStructure.associatedValidationBasedOnOtherFieldValues) {
            genericFieldStructure.associatedValidationBasedOnOtherFieldValues.rules =
                conditionalValidations;
        }
    }

    // If it's a numeric text field, use custom render for focus/blur formatting
    if (isNumeric) {
        return {
            ...genericFieldStructure,
            type: 'custom',
            render: createNumericFieldRender({
                locale,
                genericFieldStructure,
                parseValue: parseToString,
                formatForEditing,
            }),
            validations,
        } as unknown as CustomFieldStructure;
    }

    return {
        ...genericFieldStructure,
        type: 'text',
        validations,
    };
};
